/**
 * WordPress dependencies
 */
import { chevronDown, Icon } from '@safe-wordpress/icons';

/**
 * Internal dependencies
 */
import {
	chevronIconSize,
	DownArrowWrapper,
	InputControlSuffixWrapperWithClickThrough,
} from './select-control-styles';

const SelectControlChevronDown = (): JSX.Element => {
	return (
		<InputControlSuffixWrapperWithClickThrough>
			<DownArrowWrapper>
				<Icon icon={ chevronDown } size={ chevronIconSize } />
			</DownArrowWrapper>
		</InputControlSuffixWrapperWithClickThrough>
	);
};

export default SelectControlChevronDown;
